import { EquipmentList } from "@smartship-services/ui/lists";
import { useParams } from "react-router-dom";
const EquipmentListPage = () => {
  const { vesselId = "" } = useParams();
  return <EquipmentList vesselId={vesselId} />;
};

export default EquipmentListPage;
